import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { formatCurrency } from 'tio-ui/format';

interface CardBalanceSignature {
  Args: {
    /** Balance in DOLLARS (callers convert the model's cents value before passing). */
    balance: number;
    /** Last four digits of the card number. */
    last4?: string;
  };
  Element: HTMLDivElement;
}

/**
 * The CourseCash card visual (purple gradient Visa card) shown inside the
 * "Use CourseCash" task. Presentational only — the full card-details flow lives
 * in `tas/course-cash/stripe-card-display`, reached via the task's "View Card
 * Details" CTA.
 */
const CardBalance: TOC<CardBalanceSignature> = <template>
  {{! template-lint-disable no-bare-strings }}
  <div
    class="tio-course-cash-card tio-col relative aspect-[85.6/54] justify-between overflow-hidden rounded-xl p-4"
    ...attributes
  >
    <div>
      <div class="tio-text-xs-medium opacity-70">
        {{t "tuition_assistance.applications.manage.card.balance_label"}}
      </div>
      <div class="tio-text-2xl-semibold mt-1">{{formatCurrency @balance}}</div>
    </div>
    <div class="tio-row-between items-end">
      <span class="tio-text-sm-medium tracking-widest">•••• {{if @last4 @last4 "••••"}}</span>
      <span class="tio-text-sm-semibold italic">VISA</span>
    </div>
  </div>
</template>;

export default CardBalance;
